<template>
    <div
        class="image--player align-items-center d-flex flex-direction-column h-100 justify-content-center"
        @click.self="$emit('close')"
    >
        <img
            v-if="!error"
            :src="url"
            class="d-block mxw-100 mxh-100 text-center"
            @error="onerror"
            @load="load"
        />

        <div
            v-else
            class="p-32 text-center text-light"
        >
            <p>{{ $t("errors.loadingFileError") }}</p>
            ¯\_(ツ)_/¯
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true,
        },
    },

    emits: ["accessed", "close"],

    data() {
        return {
            error: false,
        }
    },

    methods: {
        load() {
            this.$emit("accessed")
        },

        onerror() {
            this.error = true
        },
    },
}
</script>
